const STATEMACHINE = {
  allow_instance_owner: true,
  description: "",
  name: "",
  sm_type: "default"
};

const ACTIVITY = {
  name: "",
  description: "",
  state_change_logic: [],
  jobs_trigger: [],
  type: "",
  details_view: {
    detailview_id: "",
    elements: [],
    is_positioned_static_data: true,
    position_config: {
      mobile: {
        config: [],
        position_config_ids: {}
      },
      desktop: {
        config: [],
        position_config_ids: {}
      }
    }
  },
  pre_activity_job: [],
  pre_submission: [],
  custom_functions: [],
  jobs_trigger_formula: "",
  activity_response: {
    error_message: "",
    success_message: ""
  }
};

const STATE = {
  name: "",
  description: "",
  remember: {
    allow_activities: [],
    allow_state_sources: [],
    allow_state_targets: [],
    deny_activities: [],
    deny_states_sources: [],
    deny_states_targets: [],
    source_activity: []
  },
  type: "intermediate"
};

const SMConfig = {
  statemachine: STATEMACHINE,
  activity: ACTIVITY,
  state: STATE
};

export { SMConfig };
